import templateUrl from "./address-snippet.html"

/**
 * A snippet containing a textual representation of an address.
 */
export const AddressSnippetComponent = {
    controller: function () { },
    bindings: {
        address: "<",
        oneLine: "<"
    },
    templateUrl
}
